<template>
    <span class="relative">
        <font-awesome-icon :icon="['far', 'envelope']" class="text-xl mr-2" />
        <font-awesome-icon :icon="['fas', 'circle']" class="absolute text-xs text-red-500" 
            v-if="unreadIcon"
        />
    </span>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";

import {mapWritableState} from 'pinia';
import inboxStore from '../Stores/inbox.js';

export default {
    name: 'InboxIcon',
    computed: {
        ...mapWritableState(inboxStore, ['activeContact', 'readContacts']),
        unreadIcon() {
            if (this.$page.props.has_unread_messages) {
                //it is only going to be read if the number of unread contacts equals the number of read contacts...
                if (this.$page.props.unread_contacts) {
                    return this.$page.props.unread_contacts.length != this.readContacts.length;
                }
                return true;
            }
            return false;
        }
    }
    
};

</script>

<style scoped>

[data-icon='circle'] {
    left: 13px;
    top: -3px;
}

</style>